import { TAG_COLORS } from "../constants/prompts";

// Helper function to get tags for display (max 2 tags)
export const getDisplayTags = (tags: string[]) => {
    if (!tags || tags.length === 0) return ["default"];
    return tags.slice(0, 2); // Show first two tags
};

// Helper function to get color for a tag
export const getTagColor = (tag: string) => {
    return TAG_COLORS[tag as keyof typeof TAG_COLORS] || "default";
};

// Helper function to check if tags have changed
export const compareTagArrays = (tags1: string[], tags2: string[]): boolean => {
    return JSON.stringify(tags1.sort()) === JSON.stringify(tags2.sort());
};
